import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button'
import { deleteCards, editFigures, filterChange, setLoadedLevels, toggleSwitch } from '../../../actions';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FilterActions, ToggleActions } from '../../../constants/constants';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';
import { _ } from '../../../functions/translator';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { CircularProgress, makeStyles } from '@material-ui/core'
import { postData } from '../../../functions/postData';
import { getFiguresData } from '../../../functions/getData';
import { getFiguregroupsMap } from '../../../functions/getter';
import InfoTooltip from '../../infoTooltip/infoTooltip';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';


function AddBreakContainer (props) {
    const { createBreakMode, breakCoordinatesModal, cardCategories, levels, protocolGroups, stages } = useSelector(state => ({
        createBreakMode: state.switches.createBreakMode,
        breakCoordinatesModal: state.breakCoordinatesModal,
        cardCategories: state.projectData.card_categories,
        levels: state.projectData.levels,
        protocolGroups: state.projectData.protocolgroups,
        stages: state.projectData.stages,
    }))

    const [selectedValues, setSelectedValues] = useState([]);
    const [activeButton, setActiveButton] = useState(false);
    const [show, setShow] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [showFailureToast, setShowFailureToast] = useState(false);

    const handleClose = () => setShow(false);

    const handleSelectChange = (event) => {
        setSelectedValues(event.target.value);
    };

    const handleClick = () => {
        props.toggleSwitch(ToggleActions.CREATE_BREAK_MODE, !createBreakMode);
        setActiveButton(!activeButton)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowLoading(true)
        try {
            const formData = new FormData(e.target);
            const card_category_id = formData.get('card_category_id');
            const level_id = formData.get('level_id');
            const initial_distance = formData.get('initial_distance');
            const end_distance = formData.get('end_distance');
            const length_per_cards_group = formData.get('length_per_cards_group');
            const searchParams = new URLSearchParams(window.location.search);
            const project_id = searchParams.get('project_id');

            const urlPost = {
                card_category_id,
                level_id,
                protocol_ids:selectedValues,
                initial_distance,
                end_distance,
                length_per_cards_group,
                four_coordinates:breakCoordinatesModal.coordinates,
                project_id
            };
            const response = await postData('/web-api/generate-lineal-construction', urlPost, 'Error en la solicitud');
            if (response.status === 'success') {
                handleReload()
                props.toggleSwitch(ToggleActions.CREATE_BREAK_MODE, false);
                setActiveButton(false)
                handleClose()
            } else {
                setShowFailureToast(true);
            }
            
        } catch (error) {
            console.error('Error:', error);
            setShowFailureToast(true);
        } finally {
            setShowLoading(false)
            setSelectedValues([])
        }
    };

    const handleReload = async () => {
        try {
            props.toggleSwitch(ToggleActions.REFRESH, true);
            await reloadFigures();
            removeCardsGroups();
            removeLoadedLevels();
            reloadLevels();
        } catch (error) {
            console.log('Error al recargar registros');
        }
        props.toggleSwitch(ToggleActions.REFRESH, false);
    }

    async function reloadFigures() {
        let figuresData = await getFiguresData(props.projectData.id);
        let figuregroupsMap = getFiguregroupsMap(figuresData);
        props.editFigures(figuresData, figuregroupsMap);
    }

    function removeCardsGroups() {
        let cardsGroupIds = [];
        for (const cardsGroupData of Object.values(props.projectData.cards_groups)) {
            if (props.levelIds.includes(cardsGroupData.attributes.level_id)) {
                cardsGroupIds.push(cardsGroupData.id);
            }
        }
        props.deleteCards(cardsGroupIds);
    }

    function removeLoadedLevels() {
        let notReloadlevelIds = [];
        for (const levelId of props.loadedLevels) {
            if (!props.levelIds.includes(levelId)) {
                notReloadlevelIds.push(levelId);
            }
        }
        props.setLoadedLevels(notReloadlevelIds);
    }

    function reloadLevels() {
        let levelIdsToReload = [...props.levelIds];
        props.filterChange(FilterActions.LEVELS, []);
        props.filterChange(FilterActions.LEVELS, levelIdsToReload);
    }

    useEffect(()=>{
        if(breakCoordinatesModal.show){
            setShow(true)
        }
    },[breakCoordinatesModal])


    const useStyles = makeStyles((theme) => ({
        selected: {
          backgroundColor: '#3f51b5 !important',
          color: 'white',
        },
      }));
    const classes = useStyles();

    const backgroundButton = activeButton ? '#fc424a' :  '#ff5300'
    return(
        <>
        <Button 
            onClick={handleClick}
            size='small' 
            style={{width:'100%', background: backgroundButton, color:"#ffffff", textTransform: 'none', fontWeight:700}}>
            <p style={{fontFamily:'Rubik', margin:'0px'}}>
                <InfoTooltip class={'float-left'} placement={'left'} message={'add tunnel break message'}/>
                { _('Agregar Quiebre') }
            </p>
        </Button>
        <Snackbar 
                className='w-100 p-0' 
                onClose={() => setShowFailureToast(false)} 
                open={showFailureToast} 
                autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="error">
                    <p className='text-center w-100 m-0'>¡{_('Ha ocurrido un error al crear el registro')}!</p>
                </MuiAlert>
            </Snackbar>
        <Modal show={show} onHide={handleClose} className="fade" style={{fontFamily:"Rubik"}}>
            <Modal.Header>
                <p style={{fontFamily:'Rubik' , margin:'0px', }}>{ _('Agregar Quiebre') }</p>
                <div className='close-button text-md' onClick={handleClose}>
                    x
                </div>
            </Modal.Header>
            <Modal.Body>
                {breakCoordinatesModal.coordinates.length != 4 ? 
                    <div><p>Debes seleccionar 4 puntos para crear un registro</p></div>
                    :
                    <Form method="POST" onSubmit={handleSubmit}>
                        <Form.Group className='mt-2' controlId="card_category_id">
                            <div className='d-flex flex-row'>
                                <div className='ml-1'><Form.Label>{_('Seleccionar Categoría')}:</Form.Label></div>
                            </div>
                            <Select name="card_category_id" required style={{backgroundColor:'#2a3038'}}>
                                {
                                    Object.values(cardCategories).map(c => {
                                        const categoryStage = stages[c.attributes.stage_id]
                                        const stageName = categoryStage?.attributes.name
                                        if(stageName){
                                            return <MenuItem key={c.id} value={c.id}>{c.attributes.name} - {stageName && stageName}</MenuItem>
                                        }
                                    })
                                }
                            </Select>
                        </Form.Group>
                        <Form.Group className='mt-2' controlId="level_id">
                            <div className='d-flex flex-row'>
                                <div className='ml-1'><Form.Label>{_('Seleccionar Piso')}:</Form.Label></div>
                            </div>
                            <Select name="level_id" required style={{backgroundColor:'#2a3038'}}>
                                {
                                    Object.values(levels).map(l => {
                                        const categoryStage = stages[l.attributes.stage_id]
                                        const stageName = categoryStage?.attributes.name
                                        if(stageName){
                                            return <MenuItem key={l.id} value={l.id}>{l.attributes.name} - {stageName && stageName}</MenuItem>
                                        }
                                    })
                                }
                            </Select>
                        </Form.Group>
                        <Form.Group className='mt-2' controlId="protocol_ids">
                            <div className='d-flex flex-row'>
                                <div className='ml-1'><Form.Label>{_('Seleccionar Protocolos')}:</Form.Label></div>
                            </div>
                            <Select name="protocol_ids" 
                                multiple 
                                required 
                                style={{backgroundColor:'#2a3038'}} 
                                value={selectedValues}
                                onChange={handleSelectChange}
                                MenuProps={{
                                    MenuListProps: {
                                    disablePadding: true,
                                    },
                                    classes: {
                                    paper: classes.paper,
                                    },
                                    PaperProps: {
                                        style: {
                                          maxHeight: 300,
                                          top: '0px',
                                          position: 'fixed',
                                        },
                                    },
                                    getContentAnchorEl: null,
                                }}
                                >
                                {
                                    Object.values(protocolGroups).map(pg => {
                                        return Object.values(pg.protocols).map(p => {
                                            if(pg.attributes.name && p.attributes.name){
                                                return <MenuItem key={p.id} value={p.id} classes={{
                                                    selected: classes.selected,
                                                }}>{`${pg.attributes.name} - ${p.attributes.name}`}</MenuItem>
                                            }
                                            
                                        })
                                    })
                                }
                            </Select>
                        </Form.Group>
                        <Form.Group className='mt-2' controlId="initial_distance">
                            <div className='ml-1'><Form.Label>{_('Inicio')} {'(mts)'}:</Form.Label></div>
                            <Form.Control type="number" step="any" min="0" name="initial_distance" required />
                        </Form.Group>
                        <Form.Group className='mt-2' controlId="end_distance">
                            <div className='ml-1'><Form.Label>{_('Fin')} {'(mts)'}:</Form.Label></div>
                            <Form.Control type="number" step="any" min="0" name="end_distance" required />
                        </Form.Group>
                        <Form.Group className='mt-2' controlId="length_per_cards_group">
                            <div className='ml-1'><Form.Label>{_('Longitud de cada registro')} {'(mts)'}:</Form.Label></div>
                            <Form.Control type="number" step="any" min="0" name="length_per_cards_group" required />
                        </Form.Group>
                        <div className='d-flex justify-content-center mt-3 mb-1'>
                            <div style={{ position: 'relative' }}>
                                <Button 
                                    size='small' 
                                    style={{ background:'#ff5300', color:"#ffffff", textTransform: 'none', fontWeight:700 }} 
                                    type="submit">
                                    <p style={{fontFamily:"Rubik", margin:'0px'}}>{ _('Agregar Quiebre') }</p>
                                </Button>
                                {showLoading && 
                                    <div style={{ position: 'absolute', top: '20%', right: '-25px' }}>
                                        <CircularProgress style={{ width:'20px', height:'20px' }} />
                                    </div>
                                }
                            </div>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
        </>
    )
}

function mapStateToProps( state ){
    return {
        projectData  : state.projectData,
        levelIds     : state.filters.levelIds,
        loadedLevels : state.loadedLevels,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        filterChange : filterChange,
        editFigures : editFigures,
        deleteCards     : deleteCards,
        setLoadedLevels : setLoadedLevels,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddBreakContainer);
